/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminMarketSnapshotStatus = {
    MarketSnapshotStatusOk: 'ok',
    MarketSnapshotStatusNoData: 'no_data',
    MarketSnapshotStatusListingGone: 'listing_gone',
    MarketSnapshotStatusError: 'error'
} as const;
export type AdminMarketSnapshotStatus = typeof AdminMarketSnapshotStatus[keyof typeof AdminMarketSnapshotStatus];


export function instanceOfAdminMarketSnapshotStatus(value: any): boolean {
    for (const key in AdminMarketSnapshotStatus) {
        if (Object.prototype.hasOwnProperty.call(AdminMarketSnapshotStatus, key)) {
            if (AdminMarketSnapshotStatus[key as keyof typeof AdminMarketSnapshotStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminMarketSnapshotStatusFromJSON(json: any): AdminMarketSnapshotStatus {
    return AdminMarketSnapshotStatusFromJSONTyped(json, false);
}

export function AdminMarketSnapshotStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketSnapshotStatus {
    return json as AdminMarketSnapshotStatus;
}

export function AdminMarketSnapshotStatusToJSON(value?: AdminMarketSnapshotStatus | null): any {
    return value as any;
}

export function AdminMarketSnapshotStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminMarketSnapshotStatus {
    return value as AdminMarketSnapshotStatus;
}

